var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flowmap-box"},[_c('el-progress',{class:[_vm.getClass],attrs:{"text-inside":true,"percentage":_vm.perfPercentage,"color":_vm.eventColor}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d4ba8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/performance/node/database-flow-map/components/FlowMapProgressbar.vue
// module id = null
// module chunks = 